export const BUS = '/bus';
export const VERSION = '/version';
